import { CheckIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  Heading,
  List,
  ListIcon,
  ListItem,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { FaRegCheckCircle } from "react-icons/fa";
import { MdKeyboardArrowRight } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import {
  BACKGROUND_COLOR_DARK,
  BACKGROUND_COLOR_LIGHT,
  documentsDetailsTab,
} from "../../constants";
import { removeAllDocuments } from "../../Redux/documentsSlice";
import ApplicationSubmittedModal from "../Modals/ApplicationSubmittedModal";
import BankStatements from "./DocumentType/BankStatements/BankStatements";
import BureauDocuments from "./DocumentType/BureauDocuments/BureauDocuments";
import FinancialStatements from "./DocumentType/FinancialStatements/FinancialStatements";
import GstDocuments from "./DocumentType/GstDocuments/GstDocuments";
import IdentificationDocument from "./DocumentType/IdentificationDocument/IdentificationDocument";

const DocumentDetailsTab = ({ currentTabIndex, handleUserTabClicked }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { firstName, lastName, applicationUUID } = useSelector(
    (store) => store.userDetails
  );

  const dispatch = useDispatch();

  return (
    <Box
      height="100%" // Take full height of the parent
      display="flex"
      flexDirection="column"
      padding="8"
    >
      {/* Header */}
      <Heading as="h3" size="lg" mb={4} textTransform={"capitalize"}>
        Welcome {firstName} {lastName}
      </Heading>

      {currentTabIndex === -1 && (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          borderWidth="1px"
          borderRadius="xl"
          paddingX={5}
          boxShadow="sm"
          paddingY={3}
          my={5}
        >
          <Text>
            Your application has been submitted. Track and manage your
            submission here.
          </Text>

          <Button
            size="sm"
            backgroundColor={"orange.400"}
            color={"white"}
            _hover={{ backgroundColor: "orange.500" }}
            display={"flex"}
            columnGap={"1"}
            fontWeight={"bold"}
            onClick={onOpen}
            borderRadius={"lg"}
          >
            Show Progress <MdKeyboardArrowRight className="h-5 w-5" />
          </Button>

          {/* Application submit modal  */}

          <ApplicationSubmittedModal
            currentActiveStep={2}
            isOpen={isOpen}
            onClose={onClose}
          />
        </Box>
      )}

      {/* Main Content Area */}
      <Flex flex="1" gap="8" mt={2}>
        {/* Sidebar */}
        <Box width="35%">
          <List spacing={2}>
            {documentsDetailsTab.map((tabName, index) => (
              <ListItem
                key={tabName}
                className={
                  "w-[95%] px-4 py-2 rounded-xl " +
                  (index === currentTabIndex ? "font-semibold " : "") +
                  (currentTabIndex === -1 &&
                  tabName === "Identification Documents"
                    ? "cursor-pointer"
                    : "")
                }
                style={{
                  color: currentTabIndex === index ? BACKGROUND_COLOR_DARK : "",
                  backgroundColor:
                    currentTabIndex === index ? BACKGROUND_COLOR_LIGHT : "",
                }}
                onClick={() => {
                  if (index === currentTabIndex) {
                    handleUserTabClicked(index);
                  }
                  if (
                    tabName === "Identification Documents" &&
                    currentTabIndex === -1
                  ) {
                    // this means user has completed the all the steps and want to restart another application
                    dispatch(removeAllDocuments());
                    handleUserTabClicked(0); // redirecting to Identification Tab
                  }
                }}
              >
                {index < currentTabIndex && (
                  <ListIcon as={CheckIcon} mr={2} color="green.500" />
                )}
                {tabName}
              </ListItem>
            ))}
          </List>
        </Box>
        {/* Content */}
        <Box flex="1" display="flex" flexDirection="column">
          {/* Render the current tab's component */}
          {documentsDetailsTab.map((tabName, index) => {
            if (currentTabIndex !== index) return null;

            switch (tabName) {
              case "Identification Documents":
                return (
                  <IdentificationDocument
                    key={tabName}
                    handleUserTabClicked={handleUserTabClicked}
                  />
                );
              case "Bank Statements":
                  return (
                    <BankStatements
                      key={tabName}
                      handleUserTabClicked={handleUserTabClicked}
                    />
                  );
              case "Financial Statements":
                return (
                  <FinancialStatements
                    key={tabName}
                    handleUserTabClicked={handleUserTabClicked}
                  />
                );
              
              case "GST Information":
                return (
                  <GstDocuments
                    key={tabName}
                    handleUserTabClicked={handleUserTabClicked}
                  />
                );
              case "Bureau Data":
                return (
                  <BureauDocuments
                    key={tabName}
                    handleUserTabClicked={handleUserTabClicked}
                  />
                );
              default:
                return null;
            }
          })}

          {/* Application Submitted View */}
          {currentTabIndex === -1 && (
            <Box
              flex="1"
              display="flex"
              alignItems="center"
              flexDirection={"column"}
              rowGap={3}
              mt={10}
            >
              <FaRegCheckCircle
                className="h-12 w-12 mt-5"
                style={{ color: BACKGROUND_COLOR_DARK }}
              />
              <Text fontSize={"xl"}>Application Submitted</Text>
            </Box>
          )}
        </Box>
      </Flex>
    </Box>
  );
};

export default DocumentDetailsTab;
